// *********************************
// INVOICE - NOT USED NUMBERS SCRIPT
// *********************************
export function loadNotUsedNumbers(serie) {
	$('#number').empty();
	$.ajax("ajax/Invoice.getNotUsedNum.jsp?serie=" + serie)
		.done(function (dobj) {
			for (let i = 0; i < dobj.length; i++) {
				let opt = '<option value="' + dobj[i].id + '">' + dobj[i].name + '</option>';
				$('#number').append(opt);
			}
		})
		.fail(function (jqXHR, textStatus, errorThrown) {
			console.log("error: "+textStatus+"  "+errorThrown);
		});
}
